import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCanAccessPharmacySetup } from '../hooks/useCanAccessPharmacySetup';

const PharmacySetupRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const ok = useCanAccessPharmacySetup();
  if (!ok) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default PharmacySetupRoute;
